<script lang="ts">
    import { page } from "$app/stores";
    const hrefAbout = "/about";
    const hrefContact = "/contact";
    const hrefFaq = "/faq";
    const hrefOrder = "/order";
    const hrefTerms = "/terms";
    const hrefPrivacy = "/privacy";
    import { goto } from "$app/navigation";
    $: classesActive = (href: string) => (href === $page.url.pathname ? "!bg-primary-500 !text-white" : "");
</script>

<ul class="list-nav">
    <li>
        <button
            class={classesActive(hrefOrder)}
            on:click={() => {
                window.location.assign(hrefOrder);
            }}
        >
            <span class="flex-auto">Order</span>
        </button>
    </li>
    <!-- <li>
        <button
            class={classesActive(hrefAbout)}
            on:click={() => {
                window.location.assign(hrefAbout);
            }}
        >
            <span class="flex-auto">About Us</span>
        </button>
    </li> -->
    <li>
        <button
            class={classesActive(hrefFaq)}
            on:click={() => {
                window.location.assign(hrefFaq);
            }}
        >
            <span class="flex-auto">FAQ</span>
        </button>
    </li>
    <li>
        <button
            class={classesActive(hrefContact)}
            on:click={() => {
                window.location.assign(hrefContact);
            }}
        >
            <span class="flex-auto">Contact</span>
        </button>
    </li>
    <!-- <li>
        <button
            class={classesActive(hrefTerms)}
            on:click={() => {
                window.location.assign(hrefTerms);
            }}
        >
            <span class="flex-auto">Terms & Conditions</span>
        </button>
    </li> -->
    <li>
        <button
            class={classesActive(hrefPrivacy)}
            on:click={() => {
                window.location.assign(hrefPrivacy);
            }}
        >
            <span class="flex-auto">Privacy Policy</span>
        </button>
    </li>
</ul>

<style>
    .list-nav {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        text-align: right;
        gap: 0.5rem;
    }
    @media screen and (max-width: 800px) {
        .list-nav {
            flex-direction: column;
            text-align: center;
        }
    }
</style>
